<template>
  <a
    v-if="shopifyLink"
    class="btn is-outline"
    :href="shopifyLink.path"
    target="_blank"
  >
    {{ $texts('product.onlineButtonText') }}
  </a>
</template>

<script lang="ts" setup>
import type { ShopifyLinkFragment } from '#graphql-operations'
import { ShopifyCountry } from '#graphql-operations'
import { Region } from '~~/settings'

const props = defineProps<{
  links: ShopifyLinkFragment[]
}>()

const { region } = useCountry()

/**
 * The matching shopify link.
 */
const shopifyLink = computed(() =>
  props.links.find((v) => {
    if (region.value === Region.CA) {
      return v.country === ShopifyCountry.CA
    } else if (region.value === Region.US) {
      return v.country === ShopifyCountry.US
    } else if (region.value === Region.UK_IE) {
      return v.country === ShopifyCountry.UK
    }
  }),
)
</script>
